/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Rounds_Choice_Swiss_Bo3Inputs */



/**
* | output |
* | --- |
* | "Swiss - BO3" |
*
* @param {Tournaments_Lib_Rounds_Choice_Swiss_Bo3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_rounds_choice_swiss_bo3 = /** @type {((inputs?: Tournaments_Lib_Rounds_Choice_Swiss_Bo3Inputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Rounds_Choice_Swiss_Bo3Inputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schweizer System - BO3")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suisse - BO3")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("瑞士轮 - BO3")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("瑞士制 - BO3")
	if (locale === "ko") return /** @type {LocalizedString} */ ("스위스 - BO3")
	return /** @type {LocalizedString} */ ("Swiss - BO3")
});